import styled from 'styled-components';

import variables from '../../styles/variables';
import Image from '../UI/Image/Image';
import Arrow from '../../images/Arrow_link.svg';

export const Card = styled.div`
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  min-height: 257px;
  width: 33%;

  background-image: url(${(props) => props.desktopImage});
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: relative;

  padding: 40px;
  &:nth-of-type(1) {
    padding-right: 80px;
  }
  &:nth-of-type(2) {
    padding-left: 80px;
    padding-right: 80px;
  }
  &:nth-of-type(3) {
    padding-left: 80px;
  }

  @media screen and (max-width: 767px) {
    padding: 30px !important;
  }
  @media screen and (min-width: 768px) and (max-width: 980px) {
    padding: 30px;
    &:nth-of-type(1) {
      padding-right: 60px;
    }
    &:nth-of-type(2) {
      padding-left: 60px;
      padding-right: 60px;
    }
    &:nth-of-type(3) {
      padding-left: 60px;
    }
  }

  @media screen and (max-width: 767px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    padding: 40px 16px;
    border-radius: 5px;
    background-color: ${variables.colorGreyLight};
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
    margin-bottom: 2rem;
    background-image: none;
  }

  button.functionalTextLink {
    color: ${variables.colorRed};
    font-weight: bold;
    font-size: 14px;
    border: none;
    background-color: transparent;
    background: none;
    padding: 0;
    cursor: pointer;
    &:after {
      content: '';
      display: inline-flex;
      position: relative;
      width: 10px;
      height: 8px;
      right: -10px;
      top: 50%;
      margin-top: -4px;
      background: url(${Arrow}) no-repeat scroll 0 0 transparent;
    }
    @media screen and (min-width: 768px) and (max-width: 980px) {
      font-size: 12px;
    }
    @media screen and (max-width: 767px) {
      &:after {
        top: 0%;
      }
    }
  }
`;

export const CardContent = styled.div`
  h2 {
    font-size: 35px;
    color: ${variables.colorRed};
  }
  h3 {
    width: 40%;
    font-size: 26px;
    color: ${variables.colorRed};
  }
  p,
  a,
  li {
    color: ${variables.colorBlack};
    font-size: 14px;
    line-height: 25px;
  }
  li {
    line-height: 1.2;
  }
  @media screen and (max-width: 767px) {
    h3 {
      width: 0%;
      display: table-footer-group;
    }
  }
`;

export const Title = styled.h3`
  color: ${variables.colorBlack};
  font-size: 26px;
  font-weight: 600;
  line-height: 1;
  @media screen and (min-width: 768px) and (max-width: 980px) {
    margin-bottom: 7px;
  }
  @media screen and (max-width: 767px) {
    font-size: 26px;
  }
`;

export const Description = styled.p`
  color: ${variables.colorBlack};
  font-size: 14px;
  line-height: 25px;
  @media screen and (min-width: 785px) and (max-width: 980px) {
    font-size: 12px;
    line-height: 20px;
    margin-bottom: 4px;
  }
  @media screen and (max-width: 784px) {
    font-size: 12px;
    line-height: 20px;
    margin-bottom: 4px;
  }
  @media screen and (max-width: 767px) {
    font-size: 13px;
  }
`;

export const Icon = styled(Image)`
  margin-bottom: 1vw;
  @media screen and (min-width: 768px) and (max-width: 980px) {
    max-width: 15px;
  }
  @media screen and (max-width: 767px) {
    margin-bottom: 1.5rem;
  }
`;

export const TextWrapper = styled.div`
  min-height: 166px;
  @media screen and (max-width: 767px) {
    min-height: 106px;
  }
`;
